// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 30101-手环绑定-批量(机器回调) POST /machine/v1/bracelet/batchBind */
export async function batchBindBracelet(
  body: API.SwimBraceletBindBatchVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOSwimUsageBatchResultVO>(
    '/machine/v1/bracelet/batchBind',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
